module.exports = __webpack_public_path__ + "static/media/time.7455f49b.png";